<ion-item-group id='listScroll'>

 <ion-item-divider color="light" class="list-title normal-divider">
    <ion-label class="title-text">
      {{ searchText ? ('AL_RESULTS' | translate) : ('ALL_SAMPLE_RECONCILIATIONS' | translate) }} ({{filteredCount}})
    </ion-label>
  </ion-item-divider>

  <!-- Show offline message if offline, regardless of data -->
  <ng-container *ngIf="isOffline">
    <ion-list>
      <ion-item class="reconciliation-list-empty">
        <div class="offline-container">
          <div class="offline-image-wrapper">
            <img src="assets/imgs/no-internet.svg" alt="No internet connection" class="offline-image" />
          </div>
          <div class="no-data-message">
            {{'PAGE_AVAILABLE_ONLY_IN_ONLINE_MODE' | translate}}
          </div>
        </div>
      </ion-item>
    </ion-list>
  </ng-container>

  <!-- Show data only when online -->
  <ng-container *ngIf="!isOffline">
    <ng-container *ngIf="hasFilteredResults else noSearchResult;">
      <ion-list>
          <div *ngFor="let sampleReconciliationCard of displayedCards; trackBy: trackByCardId">
              <main-card [viewData]='sampleReconciliationCard'></main-card>
          </div>
      </ion-list>
      <ion-infinite-scroll (ionInfinite)="doInfinite($event)" threshold="20%">
        <ion-infinite-scroll-content></ion-infinite-scroll-content>
      </ion-infinite-scroll>
    </ng-container>

    <ng-template #noSearchResult>
      <ind-no-search-result *ngIf="searchText && !hasFilteredResults else noData;" [text]="('NO_RESULTS_FOR_THIS_SEARCH' | translate)"></ind-no-search-result>
    </ng-template>
    <ng-template #noData>
      <ion-list>
          <ion-item class="reconciliation-list-empty">
              <div class="no-data-message">
                {{'NO_RECONCILIATIONS' | translate}}
              </div>
          </ion-item>
      </ion-list>
    </ng-template>
  </ng-container>

</ion-item-group>
